import API from 'utils/API'

export const fetchUsers = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/user${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const createUser = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/dashboard/user', payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const deleteUser = id => (
  () => new Promise((resolve, reject) => (
    API.delete(`/dashboard/user/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchUserDetail = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/user/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const updateUser = (id, payload) => (
  () => new Promise((resolve, reject) => (
    API.put(`/dashboard/user/${id}`, payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchRoles = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/role/`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
